import { configureStore } from '@reduxjs/toolkit';
import profileSlice from './slices/profileSlice';
import loginSlice from './slices/loginSlice';

const store = configureStore({
	reducer: {
		auth: loginSlice.reducer,
		userProfile: profileSlice.reducer,
	},
});

export default store;
export type AppDispatch = typeof store.dispatch;
